import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ArcClaimPagedResultDto } from './pagedResult.dto'

@ObjectType()
export class GroupedArcClaimResultDto {
  @Field(t => Int)
  activeCount!: number

  @Field(t => Int)
  dueCount!: number

  @Field(t => Int)
  delayedCount!: number

  @Field(t => Int)
  pendingPublishingCount!: number

  @Field(t => Int)
  completeCount!: number

  @Field(t => Int)
  cancelledCount!: number

  @Field(t => ArcClaimPagedResultDto)
  result!: ArcClaimPagedResultDto
}
